// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwWidget from 'viewmodel/AwWidgetViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "suppliers": {
      "displayName": "{{i18n.emailAddress}}",
      "type": "STRINGARRAY",
      "isRequired": "false",
      "isEditable": "true",
      "isArray": "true",
      "labelPosition": "PROPERTY_LABEL_AT_TOP",
      "requiredText": "{{i18n.enterSupplierEmail}}"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "actions": {
    "addSuppliers": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation AddSuppliers( $collaborationspaceId: String, $rfqId: String, $addRfqSupplierInput: Json) { addSuppliers( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, addRfqSupplierInput: $addRfqSupplierInput ) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}",
              "addRfqSupplierInput": {
                "suppliers": "{{data.suppliers}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "suppliersAdded": "data.data.addSuppliers"
      },
      "events": {
        "success": [{
          "condition": "suppliersAdded.error === undefined",
          "name": "add-suppliers.success",
          "eventData": {
            "suppliersAdded": "{{suppliersAdded}}"
          }
        }, {
          "condition": "suppliersAdded.error === 'EMPTY_COLLAB_SPACE'",
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "suppliersAdded.error.statusCode === 400 || errorCode === 400",
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{suppliersAdded.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "suppliersAdded.error.statusCode === 403 || errorCode === 403",
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "suppliersAdded.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "suppliersAdded.error.statusCode >= 500 && suppliersAdded.error.statusCode <= 599",
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "add-suppliers.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "add-suppliers.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-suppliers.success",
      "eventData": "{{eventData.suppliersAdded}}"
    }
  }, {
    "eventId": "add-suppliers.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-add-suppliers.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "conditions": {},
  "i18n": {
    "emailAddress": ["RfqMessages"],
    "enterSupplierEmail": ["RfqMessages"],
    "Add": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "AddSupplier",
  "_uniqueViewModelId": "AddSupplier",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table height="">
        <tr class="tableBody">
            <td>
                <aw-widget prop="data.suppliers"></aw-widget>
            </td>
        </tr>
        <tr class="tableFooter">
            <td>
                <aw-button action="addSuppliers" size="auto">{{i18n.Add}}</aw-button>
            </td>
        </tr>
    </table>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwWidget, getField("data.suppliers", fields, $index, null, null)))), /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwButton, {
    action: actions.addSuppliers,
    size: "auto"
  }, AwParseService.instance("i18n.Add")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;